import React, { useEffect, useState } from 'react';
import { Snowflake, UserCheck, Briefcase, ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';
import api from '../lib/api';
import VehicleBookingDialog from './VehicleBookingDialog';

const FleetSection = () => {
  const { t, lang } = useLanguage();
  const [vehicles, setVehicles] = useState([]);
  const [bookVehicle, setBookVehicle] = useState(null);

  useEffect(() => {
    api.get('/vehicles').then(r => setVehicles(r.data)).catch(() => {});
  }, []);

  const featureIcons = [Snowflake, UserCheck, Briefcase];

  const handleReserve = (v) => {
    setBookVehicle(v);
  };

  return (
    <section id="fleet" className="py-24 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-[#ff6b1a] text-sm font-bold tracking-[0.2em] uppercase">{t.fleet.tag}</span>
          <h2 className="text-4xl md:text-5xl font-black text-white mt-3 mb-4">{t.fleet.title}</h2>
          <p className="text-white/60 max-w-3xl mx-auto text-lg">{t.fleet.subtitle}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
          {vehicles.map((v) => (
            <div key={v.id} className="glass-card rounded-xl overflow-hidden card-hover group">
              <div className="relative h-52 overflow-hidden">
                <img src={v.image} alt={v.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
                <div className="absolute bottom-3 left-4 right-4">
                  <div className="text-xs text-[#ff6b1a] font-bold uppercase tracking-wider">{v.capacity}</div>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-white mb-3">{lang === 'en' && v.name_en ? v.name_en : v.name}</h3>
                <p className="text-white/60 text-sm leading-relaxed mb-5">{lang === 'en' && v.description_en ? v.description_en : v.description}</p>
                <div className="flex flex-wrap gap-2 mb-5">
                  {(v.features || []).slice(0, 3).map((f, i) => {
                    const Icon = featureIcons[i] || Briefcase;
                    return (
                      <span key={i} className="inline-flex items-center gap-1 text-xs bg-white/5 text-white/70 px-2.5 py-1 rounded-md border border-white/10">
                        <Icon className="w-3 h-3 text-[#ff6b1a]" /> {f}
                      </span>
                    );
                  })}
                </div>
                <Button onClick={() => handleReserve(v)} className="btn-orange border-0 w-full rounded-md gap-2">
                  {t.fleet.reserve} <ArrowRight className="w-4 h-4" />
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
      <VehicleBookingDialog vehicle={bookVehicle} open={!!bookVehicle} onOpenChange={(v) => !v && setBookVehicle(null)} />
    </section>
  );
};

export default FleetSection;
